<script>
import { Bubble, mixins } from 'vue-chartjs'
export default {
	extends: Bubble,
	mixins: [mixins.reactiveProp, mixins.reactiveData],
	props: ['data', 'options'],
	mounted () {
		this.renderChart(this.data, this.options)
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/config/bubble.vue